export const SET_SLIPS = 'SET_SLIPS';
export const DELETE_SLIP = 'DELETE_SLIP';
export const VALIDATE_SLIP = 'VALIDATE_SLIP';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_STATUSES_COUNT = 'SET_STATUSES_COUNT';
export const SET_LIMIT = 'SET_LIMIT';
